import * as Three from 'three';
import React from 'react';
import { lineBreakWord } from '../../../common/functions/helperFunctions';

const WIDTH = 30;
const DEPTH = 60;

export default {
    name: 'hot-plate',
    prototype: 'items',

    info: {
        tag: ['metal'],
        title: 'Hot Plate',
        description: 'Hot Plate',
        image: require('./hotPlate.PNG')
    },

    properties: {
        altitude: {
            label: 'altitude',
            type: 'length-measure',
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
        let angle = element.rotation + 90;
        let textRotation = 0;
        let desc = lineBreakWord(element.desc, 20);
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }

        return (
            <g transform={`translate(${-WIDTH / 2},${-DEPTH / 2})`}>
                <rect key="1" x="0" y="0" width={WIDTH} height={DEPTH}
                    style={style} />
                <circle key="2" cx={15} cy={15} r={8} style={style} />
                <circle key="3" cx={15} cy={DEPTH - 15} r={9} style={style} />
                <line key="4" x1={0} y1={DEPTH / 2} x2={WIDTH} y2={DEPTH / 2} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
                <text key="10" x="0" y="0"
                    transform={`translate(${textRotation === 0 ? -WIDTH : WIDTH}, ${textRotation === 0 ? -5 : DEPTH + 5}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "left", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene) {
        const WIDTH = 40;
        const DEPTH = 80;
        const HEIGHT = 20;

        //let angle = element.rotation + 90;
        let textRotation = 0;
        let desc = lineBreakWord(element.desc, 20);
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" }
        let styleRight = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "#ccc" }
        let styleFront = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "#eee" }

        // if (Math.sin(angle * Math.PI / 180) < 0) {
        //     textRotation = 180;
        // }

        return (
            // no-rotation means that the item would not be rotated in src\components\viewerAxonometric\item.jsx!
            <g transform={`translate(${-WIDTH / 1.2}, -100)`} key='no-rotation'>
                <rect key="8" x="0" y={-HEIGHT} width={WIDTH} height={HEIGHT} style={styleFront} />
                <g transform={`scale(1, 0.5) skewX(27)`}>
                    <rect key="1" x="0" y="0" width={WIDTH} height={DEPTH} style={style} />
                    <circle key="2" cx={WIDTH / 2} cy={DEPTH / 4} r={WIDTH / 4} style={style} />
                    <circle key="3" cx={WIDTH / 2} cy={3 * DEPTH / 4} r={WIDTH / 4} style={style} />
                    <line key="6" x1="0" y1={DEPTH / 2} x2={WIDTH} y2={DEPTH / 2} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
                </g>
                <g transform={`translate(${WIDTH}, 0) skewY(45)`}>
                    <rect key="8" x="0" y={-HEIGHT} width={WIDTH} height={HEIGHT} style={styleRight} />
                </g>
                {element.productCount
                    ? <>
                        <path d={`M${WIDTH + 3} -2 L${WIDTH + 50} 20`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                        <path d={`M${WIDTH + 50} 20 L${WIDTH + 70} 20`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                        <circle id="3" cx={`${WIDTH + 70}`} cy="20" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                        <text
                            x={`${WIDTH + 70}`}
                            y="-20"
                            fontFamily="Arial"
                            alignmentBaseline="middle"
                            textAnchor="middle"
                            fontSize={24}
                            fill="#000000"
                            transform={`scale(1,-1) rotate(${textRotation})`}
                        >
                            {element.productCount}
                        </text>
                    </>
                    : <text key="10" x="0" y="0"
                        transform={`translate(${WIDTH + 5}, ${textRotation === 0 ? -5 : DEPTH + 5}) scale(1,-1) rotate(${textRotation})`}
                        style={{ textAnchor: "left", fontSize: "11px" }}>
                        {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                    </text>}
            </g>
        )
    }
};
